import { useQuery } from "@tanstack/react-query";

import { CustomModelPriceSuggestionsResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { jsonAuthHeaders } from "@/utils/headers";

const EMPTY_RESPONSE: CustomModelPriceSuggestionsResponse = {
  success: true,
  suggested_models: [],
};

export const useCustomModelPriceSuggestions = (
  authToken: string,
  workspaceId: string | undefined,
) =>
  useQuery<CustomModelPriceSuggestionsResponse>({
    queryKey: ["customModelPriceSuggestions", workspaceId],
    enabled: Boolean(workspaceId),
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.custom_model_prices.suggestions(String(workspaceId)), {
        headers: jsonAuthHeaders(authToken),
        method: "GET",
      });
      if (!response.ok) {
        return EMPTY_RESPONSE;
      }
      return response.json();
    },
  });
